import { AnimatePresence, motion } from 'framer-motion'
import type { ReactNode } from 'react'
import { useViewStore } from '@/state/useViewStore'
import { MainDashboard } from './MainDashboard'
import { WeeklyReportView } from './WeeklyReportView'
import { MonthlyReportView } from './MonthlyReportView'

const VIEWS: Record<string, () => ReactNode> = {
  main: () => <MainDashboard />,
  weekly: () => <WeeklyReportView />,
  monthly: () => <MonthlyReportView />,
}

export function ViewSwitcher() {
  const viewMode = useViewStore((s) => s.viewMode)
  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={viewMode}
        initial={{ opacity: 0, y: 16, scale: 0.99 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, y: -8, scale: 1 }}
        transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
        className="size-full"
      >
        {VIEWS[viewMode]?.()}
      </motion.div>
    </AnimatePresence>
  )
}
